import request from '@/utils/ajax';

/**
 * //微信公众号列表
 * @param data
 * @returns {*}
 */
export function queryWxPublicAccountList(data){
  return request({
    url: `/wx/manage/wxAccount/list`,
    method: 'get',
  });
}

/**
 * /微信公众号粉丝列表
 * @param data
 * @returns {*}
 */
export function queryWxPublicAccountFansList(data){
  return request({
    url: `/wx/manage/wxUser/listWithoutCookie`,
    method: 'get',
    params: data
  });
}

/**
 * 个人微信好友列表
 * @param data
 * @returns {*}
 */
export function queryPersonalWxFriendsList(data){
  return request({
    url: `/wx/manage/wxBotClientFriend/list`,
    method: 'get',
    params: data
  });
}

/**
 * 个人微信机器人列表
 * @param data
 * @returns {*}
 */
export function queryPersonalWxBotList(data){
  return request({
    url: `/wx/manage/wxBotClientInfo/list`,
    method: 'get',
    params: data
  });
}

/**
 * 获取爬虫策略列表
 * @param data
 * @returns {*}
 */
export function queryReptileStrategyList(data){
  return request({
    url: `/wx/manage/forwardStrategy/scheduledSpiderSource`,
    method: 'get',
    params: data
  });
}

/**
 * 保存策略
 * @param data
 * @returns {*}
 */
export function saveStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/save`,
    method: 'post',
    data: data
  });
}

/**
 * 更新策略
 * @param data
 * @returns {*}
 */
export function updateStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/update`,
    method: 'put',
    data: data
  });
}
/**
 * 删除策略 暂没有 todo
 * @param data
 * @returns {*}
 */
export function deleteStrategy(data){
  return request({
    url: `/wx/manage/forwardStrategy/delete`,
    method: 'post',
    data: data
  });
}

function parseTelegramMemberIds(value) {
  const text = String(value || '').trim();
  if (!text) return [];
  const unique = [];
  text.split(/[\s,，]+/).filter(Boolean).forEach(rawId => {
    if (!/^\d+$/.test(rawId)) {
      throw new Error('Telegram成员ID必须为正整数');
    }
    const userId = Number(rawId);
    if (userId <= 0 || userId > 9007199254740991 || Math.floor(userId) !== userId) {
      throw new Error('Telegram成员ID必须为正整数且不能超出安全整数范围');
    }
    if (!unique.includes(userId)) unique.push(userId);
  });
  return unique;
}

export function buildStrategyPayload(form) {
  const payload = {...form};
  delete payload.telegramMemberIds;
  delete payload.sourceOfficialName;
  delete payload.sourceNickname;
  delete payload.authorNickName;
  delete payload.content;
  delete payload.createTime;
  delete payload.updateTime;

  if (payload.sourceType === 5) {
    const sourceId = String(payload.sourceId || '').trim();
    const authorId = String(payload.authorId || '').trim();
    if (!/^[1-9]\d*$/.test(sourceId)) {
      throw new Error('请选择Telegram机器人配置');
    }
    if (!/^-?\d+$/.test(authorId)) {
      throw new Error('Telegram会话ID必须为整数');
    }
    payload.sourceId = sourceId;
    payload.authorId = authorId;
    payload.telegramMembers = authorId.startsWith('-')
      ? parseTelegramMemberIds(form.telegramMemberIds).map(userId => ({userId}))
      : [];
    delete payload.larkMembers;
  } else if (payload.sourceType === 6) {
    const sourceId = String(payload.sourceId || '').trim();
    const authorId = String(payload.authorId || '').trim();
    if (!/^[1-9]\d*$/.test(sourceId)) {
      throw new Error('请选择Lark应用配置');
    }
    if (!authorId.startsWith('oc_')) {
      throw new Error('Lark会话ID不合法，仅支持群聊chat_id（oc_开头）');
    }
    payload.sourceId = sourceId;
    payload.authorId = authorId;
    // 后端要求显式提交 larkMembers：空数组=整群采集，非空=白名单
    payload.larkMembers = (form.larkMembers || []).map(item => {
      const openId = String((item && item.openId) || '').trim();
      if (!openId) {
        throw new Error('Lark成员openId不能为空');
      }
      return {openId, name: (item && item.name) ? String(item.name) : ''};
    });
    delete payload.telegramMembers;
  } else {
    delete payload.telegramMembers;
    delete payload.larkMembers;
  }
  return payload;
}
